import React from 'react';
import { TabSelect, TabSelectOption, TabSelectOptionSubTitle, TabSelectOptionTitle } from './TabSelect-styled';


export interface ITabSelectTab {
  title:string,
  subTitle:string,
  isActive:boolean,
  onClick:(e?:any)=>any
}

interface Props {
  className?:string,
  tabs:ITabSelectTab[]
}

export default ({
  className,
  tabs
}:Props):JSX.Element => (
  <TabSelect
    className={className}
  >
    {tabs.map((tab, index) => {
      return(
        <TabSelectOption
          key={index}
          className={tab.isActive ? 'active' : ''}
          onClick={tab.onClick}
        >
          <TabSelectOptionTitle>{tab.title}</TabSelectOptionTitle>
          <TabSelectOptionSubTitle>{tab.subTitle}</TabSelectOptionSubTitle>
        </TabSelectOption>
      );
    })}
  </TabSelect>
);
